import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import EChart from '../../../components/echart/EChart'
import Pie from '../../../components/echart/series/Pie'
import { DECLARATION_STATUS } from 'agriAdministration/constants/AgriConstants'
import { includes } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import { NoDataPanel } from 'components/card/NoDataCard'

const ProgressSurveyChart = () => {
    const {
        survey: { link_declarations: declarations = [] },
    } = useSelector(store => ({
        survey: store.AgriReducer.survey,
    }), shallowEqual)

    const chart = useMemo(() => (declarations.length && (
        <EChart options={{
            series: [
                Pie({
                    data: [
                        {
                            value: declarations.filter(dec => dec.statusCode === DECLARATION_STATUS.VALIDATED).length,
                            itemStyle: {
                                normal: {
                                    color: 'blue',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.validatedDefinitely} : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.statusCode === DECLARATION_STATUS.VALIDATED_BY_ADMIN).length,
                            itemStyle: {
                                normal: {
                                    color: 'green',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.validatedByAdmin} : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.statusCode === DECLARATION_STATUS.FINALIZED_BY_AGRI).length,
                            itemStyle: {
                                normal: {
                                    color: 'lightgreen',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.finalizedByUser} : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.statusCode === DECLARATION_STATUS.STARTED).length,
                            itemStyle: {
                                normal: {
                                    color: 'grey',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.inProgress} : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => includes(DECLARATION_STATUS.NOT_STARTED, dec.statusCode)).length,
                            itemStyle: {
                                normal: {
                                    color: 'red',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.notStarted} : {c} ({d}%)`,
                            },
                        },
                    ],
                    selectedMode: 'single',
                    radius: ['0%', '60%'],
                }),
                Pie({
                    data: [
                        {
                            value: declarations.filter(dec => dec.lastStep === 4 && dec.statusCode === DECLARATION_STATUS.STARTED).length,
                            itemStyle: {
                                normal: {
                                    color: 'forestgreen',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.step} 4 : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.lastStep === 3 && dec.statusCode === DECLARATION_STATUS.STARTED).length,
                            itemStyle: {
                                normal: {
                                    color: 'seagreen',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.step} 3 : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.lastStep === 2 && dec.statusCode === DECLARATION_STATUS.STARTED).length,
                            itemStyle: {
                                normal: {
                                    color: 'mediumaquamarine',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.step} 2 : {c} ({d}%)`,
                            },
                        },
                        {
                            value: declarations.filter(dec => dec.lastStep === 1 && dec.statusCode === DECLARATION_STATUS.STARTED).length,
                            itemStyle: {
                                normal: {
                                    color: 'darkseagreen',
                                },
                            },
                            tooltip: {
                                trigger: 'item',
                                position: 'inside',
                                formatter: `${i18n.step} 1 : {c} ({d}%)`,
                            },
                        },
                    ],
                    selectedMode: 'single',
                    radius: ['70%', '90%'],
                }),
            ],
            height: 220,
        }}
        />
    )), [declarations])

    return chart || <NoDataPanel />
}

export default ProgressSurveyChart
